import { create } from 'zustand'

/**
 * КОРОТКОЕ СООБЩЕНИЕ ВНИЗУ ЭКРАНА
 *
 * Есть действия, у которых нет видимого следа: скопировал текст,
 * скопировал код приглашения, поставил напоминание. Человек нажал —
 * и не понял, случилось ли что-нибудь. Особенно когда не случилось:
 * браузер отказал в доступе к буферу, а на экране ровно ничего.
 *
 * Полоска внизу живёт две секунды и ничего не требует: её не нужно
 * закрывать, она не перекрывает то, с чем работают, и не копится
 * стопкой — новая заменяет предыдущую.
 */
type Toast = { text: string; kind: 'ok' | 'bad'; at: number }

type ToastState = {
  toast: Toast | null
  say: (text: string, kind?: 'ok' | 'bad') => void
  hide: () => void
}

export const useToast = create<ToastState>((set) => ({
  toast: null,
  say: (text, kind = 'ok') => set({ toast: { text, kind, at: Date.now() } }),
  hide: () => set({ toast: null }),
}))

/** Короткий путь: `say('Скопировано')` из любого места. */
export const say = (text: string, kind: 'ok' | 'bad' = 'ok'): void =>
  useToast.getState().say(text, kind)
